import { render, staticRenderFns } from "./kyc-manager.vue?vue&type=template&id=09e23aa7&"
import script from "./kyc-manager.vue?vue&type=script&lang=js&"
export * from "./kyc-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports